










































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import CustomDialog from '@/components/global/CustomDialog.vue';
import InsertCsvDialog from '@/components/global/InsertCsvDialog/InsertCsvDialog.vue';
import { certificate } from '@/plugins/papybase/papybaseInit';
import {
    CSVFile, ADD_CSV_FILE, CSVData, LogInfoPayload, LogInfo, ADD_LOG_INFO, CSVLog,
} from '@/store/modules/csv';
import { map, chunk, clone } from 'lodash';
import { setTimeout, setInterval, clearInterval } from 'timers';
import moment from 'moment';

@Component({
    components: {
        InsertCsvDialog,
        CustomDialog,
    },
})
export default class UploadCsv extends Vue {
    public showInsertCsvDialog = false;
    public showLoadingDialog = false;

    public theCsvFile: CSVFile = {
        uid: '',
        name: '',
        headers: [],
        data: [],
        createdAt: '',
        updatedAt: '',
    }

    public selected: CSVData[] = [];

    public logInfos: LogInfoPayload[] = [];

    public currentCount = 0;
    public success = 0;
    public failed = 0;

    public toggleAll() {
        if (this.selected.length) this.selected = [];
        else this.selected = this.theCsvFile.data.slice();
    }

    public onInsert(csvFile: CSVFile) {
        this.theCsvFile = csvFile;
        this.selected = this.theCsvFile.data;
    }

    public onClickFinish() {
        // reset logInfos
        this.logInfos = [];
        this.success = 0;
        this.failed = 0;
        // reset current item count
        this.currentCount = 0;

        // show loading dialog
        this.showLoadingDialog = true;

        this.initCertGeneration(this.selected[this.currentCount]);
    }

    public initCertGeneration(data: CSVData) {
        const dataClone = clone(data);
        delete dataClone.id;

        const uuid: any = data['Serial No.'];
        certificate.generateCertificateNem(
            this.jwt,
            uuid,
            JSON.stringify(dataClone),
            2,
        ).then((res) => {
            const logInfoPayload: LogInfoPayload = {
                csvUid: this.theCsvFile.uid,
                csvData: data,
                logInfo: {
                    code: 'Success',
                    message: 'The product certificate successfully generated',
                },
            };

            this.logInfos.push(logInfoPayload);
            this.success += 1;
        }).catch((error) => {
            const theError: LogInfo = {};
            theError.code = 'Failed';

            if (error.message === 'FAILURE_INSUFFICIENT_BALANCE') {
                theError.message = 'Insufficient balance';
            } else {
                theError.message = error.message;
            }

            const logInfoPayload: LogInfoPayload = {
                csvUid: this.theCsvFile.uid,
                csvData: data,
                logInfo: theError,
            };

            this.failed += 1;
            this.logInfos.push(logInfoPayload);
            this.$store.commit(ADD_LOG_INFO, logInfoPayload);
        }).finally(() => {
            this.currentCount += 1;

            if (this.currentCount < this.totalCount) {
                this.initCertGeneration(this.selected[this.currentCount]);
            }
        });
    }

    get jwt() {
        return this.$store.getters.getJwt;
    }

    get theHeaders() {
        const headers = map(this.theCsvFile.headers, header => ({
            text: header,
            value: header,
            align: 'left',
            sortable: false,
        }));

        return headers;
    }

    get totalCount() {
        return this.selected.length;
    }

    get currentCountPercentage() {
        return this.currentCount / this.totalCount * 100;
    }

    get loadingDone() {
        return this.currentCount >= this.totalCount;
    }
}
